import type { SerializedHardwarePackage } from '@enmon/commons/lib/tools';
import { useServices } from 'containers/services';
import { useAppNotifications } from 'hooks';
import type { CreateHardwarePackageArg } from 'lib/services/hardwarePackagesApi';
import { type MutationOptions, useMutation, type UseMutationResult } from 'react-query';
import { getErrorMessage } from 'utils/getErrorMessage';
import { MUTATION_KEYS } from 'utils/queryKeys';

export const useCreateHardwarePackage = ({
  onSuccess,
}: Pick<
  MutationOptions<SerializedHardwarePackage, unknown, CreateHardwarePackageArg>,
  'onSuccess'
> = {}): UseMutationResult<SerializedHardwarePackage, unknown, CreateHardwarePackageArg> => {
  const { hardwarePackagesApiClient } = useServices();
  const appNotification = useAppNotifications();

  return useMutation(async (arg: CreateHardwarePackageArg) => await hardwarePackagesApiClient.create(arg), {
    mutationKey: MUTATION_KEYS.hardwarePackages.create(),
    onError: error => {
      appNotification.error({
        message: 'There was an error while creating hardware package',
        description: getErrorMessage(error),
      });
    },
    onSuccess: (data, variables, context) => {
      appNotification.success({
        message: `Hardware package created`,
      });
      onSuccess?.(data, variables, context);
    },
  });
};
